import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isError: false,
  isNotify: false,
  typeNotify: "",
  isLoading: false,
  callBackRequest: false,
  isOpenModalAddSurvey: false,
  isOpenModalDetail: false,
  isOpenModalEditSurvey: false,
  isOpenModalConfirm: false,
  isOpenModalGetLog: false,
  dataStatistics: [],
  dataOverview: [],
  dataLog: [],
  contentConfirm: "",
  idSurvey: "",
  refetchAPI: false,
  detailByID: [],
  data: [],
  total: 0,
  dataDetailQuestion: [],
  dataDetailByCard: [],
  dataDetailSurveyByCard: [],
  listQuestionById: [],
  config: {
    search: "",
    status: 0,
    typeSurvey: 0,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
  configStatistics: {
    search: "",
    status: 0,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
  bodyReportSurveyOverView: {
    id: 0,
    typeSurvey: 0,
    typeTime: 0,
    timeStart: "",
    timeEnd: "",
  },
};
const SurveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.typeNotify = "";
      state.isLoading = false;
      state.callBackRequest = false;
      state.isOpenModalAddSurvey = false;
      state.isOpenModalDetail = false;
      state.isOpenModalEdit = false;
      state.isOpenModalConfirm = false;
      state.isOpenModalGetLog = false;
      state.dataLog = [];
      state.contentConfirm = "";
      //   state.idProduct = "";
      state.isOpenModalAddCategry = false;
      state.callBackRequestCategory = false;
      state.detailByID = [];
      state.data = [];
      state.total = 0;
      state.dataCategory = [];
      state.config.search = "";
      state.config.categoryId = 0;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
    },
    setCategoryId: (state, action) => {
      state.config.categoryId = action.payload;
    },
    setPageProduct: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setSearchText: (state, action) => {
      state.config.search = action.payload;
    },
    setTypeSurvey: (state, action) => {
      state.config.typeSurvey = action.payload;
    },
    setStatusSurvey: (state, action) => {
      state.config.status = action.payload;
    },
    setOpenEditSurvey: (state, action) => {
      state.isOpenModalEditSurvey = action.payload.isOpen;
      state.idSurvey = action.payload.id;
    },
    setOpenModalAddSurvey: (state, action) => {
      state.isOpenModalAddSurvey = action.payload;
    },
    setOpenModalGetLogStore: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
    resetStatus: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
    },
    setOpenNotifySurvey: (state, action) => {
      state.isNotify = action.payload.isOpen;
      state.msg = action.payload.msg;
      state.typeNotify = action.payload.type;
    },
    setConfigStatistics: (state, action) => {
      state.configStatistics.search = action.payload.textSearch;
      state.configStatistics.status = action.payload.status;
      state.configStatistics.option.offset = action.payload.offset;
      state.configStatistics.option.order = action.payload.order;
    },
    setConfigReportOverview: (state, action) => {
      state.bodyReportSurveyOverView.typeTime = action.payload.typeTime;

      state.bodyReportSurveyOverView.id = action.payload.id;
      state.bodyReportSurveyOverView.typeSurvey = action.payload.typeSurvey;
      state.bodyReportSurveyOverView.timeStart = action.payload.timeStart;
      state.bodyReportSurveyOverView.timeEnd = action.payload.timeEnd;
    },
    setOpenModalGetLogSurvey: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // lấy toàn bộ dự liệu cho trang quản lý khảo sát
      .addCase(getDataSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataSurvey.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.data = action.payload.data.data;
          state.total = action.payload.data.total;
        }
      })
      .addCase(getDataSurvey.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      //thêm mới cuộc khảo sát
      .addCase(addSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addSurvey.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        }
        if (action.payload.status === 200 || action.payload.status === 1) {
          state.isNotify = true;
          state.isLoading = false;
          state.isError = false;
          state.typeNotify = "success";
          state.msg = "Thêm khảo sát thành công";
          state.callBackRequest = true;
          state.isOpenModalAddSurvey = false;
        }
      })
      .addCase(addSurvey.rejected, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //Chỉnh sửa cuộc khảo sát
      .addCase(editSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editSurvey.fulfilled, (state, action) => {
        if (action.payload === 1 || action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Sửa thông khảo sát thành công";
          state.callBackRequest = true;
          state.typeNotify = "success";
          state.isOpenModalEditSurvey = false;
        }
      })
      .addCase(editSurvey.rejected, (state) => {
        state.isNotify = true;
        state.typeNotify = "error";
        state.msg = "Sửa thông tin khảo sát thất bại";
        state.isLoading = false;
      })

      // xóa cuộc khảo sát
      .addCase(deleteSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSurvey.fulfilled, (state, action) => {
        if (action.payload === 200 || action.payload === 1) {
          state.isNotify = true;
          state.callBackRequest = true;
          state.typeNotify = "success";
          state.msg = "Xóa cuộc khảo sát thành công";
        } else {
          state.isNotify = true;
          state.msg = "Xóa cuộc khảo sát thất bại";
          state.typeNotify = "error";
        }
      })
      .addCase(deleteSurvey.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //xóa câu hỏi trong 1 cuộc khảo sát cụ thể
      .addCase(deleteQuestion.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteQuestion.fulfilled, (state, action) => {
        if (action.payload === 200 || action.payload === 1) {
          state.isNotify = true;
          state.callBackRequest = true;
          state.msg = "Xóa câu hỏi thành công";
        } else {
          state.isNotify = true;
          state.msg = "Xóa câu hỏi thất bại";
          state.typeNotify = "error";
        }
      })
      .addCase(deleteQuestion.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy thông tin cuộc khảo sát theo id
      .addCase(getDetailSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailSurvey.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.callBackRequest = false;
        state.detailByID = action.payload;
      })
      .addCase(getDetailSurvey.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy thông tin cuộc khảo sát theo id
      .addCase(getDataStatisticsSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataStatisticsSurvey.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.dataStatistics = action.payload.data.data;
          state.total = action.payload.data.total;
        }
      })
      .addCase(getDataStatisticsSurvey.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy thông tin dữ liệu thống kê tổng quát
      .addCase(getReportSurveyOverView.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportSurveyOverView.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.dataOverview = action.payload.data;
        }
      })
      .addCase(getReportSurveyOverView.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy danh sách câu hỏi theo id
      .addCase(getListQuestionById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListQuestionById.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.listQuestionById = action.payload.data;
        }
      })
      .addCase(getListQuestionById.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy danh sách thống kê theo câu hỏi
      .addCase(getReportQuestionsSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportQuestionsSurvey.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.dataDetailQuestion = action.payload.data;
        }
      })
      .addCase(getReportQuestionsSurvey.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy danh sách câu hỏi theo thẻ khách hàng
      .addCase(getReportSurveyByCard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportSurveyByCard.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.dataDetailByCard = action.payload;
        }
      })
      .addCase(getReportSurveyByCard.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //getLog
      .addCase(getLogSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogSurvey.fulfilled, (state, action) => {
        state.dataLog = action.payload;
        state.isOpenModalGetLog = true;
        state.isLoading = false;
      })
      .addCase(getLogSurvey.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // lấy chi tiết cuộc khảo sát theo card
      .addCase(getDetailReportSurveyByCard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailReportSurveyByCard.fulfilled, (state, action) => {
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        } else {
          state.isLoading = false;
          state.callBackRequest = false;
          state.isError = false;
          state.dataDetailSurveyByCard = action.payload;
        }
      })
      .addCase(getDetailReportSurveyByCard.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      });
  },
});
export default SurveySlice;

export const {
  resetStatus,
  setSearchText,
  setOpenModalAddSurvey,
  resetState,
  setOpenEditSurvey,
  setOpenNotifySurvey,
  setStatusSurvey,
  setTypeSurvey,
  setConfigReportOverview,
  setOpenModalGetLogSurvey,
  setConfigStatistics,
} = SurveySlice.actions;
// request thêm mới cuộc khảo sát
export const addSurvey = createAsyncThunk(
  "survey/addSurvey",
  async (body, thunkAPI) => {
    try {
      const res = await instance.post("/survey/createSurvey", body);
      return res.data;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 400) {
        // Trả về một giá trị bị từ chối với thông điệp lỗi từ server
        return thunkAPI.rejectWithValue(error.response.data);
      }
      return error.reponse;
    }
  }
);
// request lấy dữ liệu, phân trang các cuộc khảo sát
export const getDataSurvey = createAsyncThunk(
  "survey/getDataSurvey",
  async (config) => {
    try {
      const res = await instance.post("/survey/pageable", config);
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
//Request chỉnh sửa cuộc khảo sát
export const editSurvey = createAsyncThunk(
  "survey/editSurvey",
  async (data) => {
    try {
      const res = await instance.put("/survey/updateSurvey", data, {});
      return res.data.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
//Request xóa cuộc khảo sát
export const deleteSurvey = createAsyncThunk(
  "survey/deleteSurvey",
  async (id) => {
    try {
      const res = await instance.delete(`/survey/deleteSurvey/${id}`);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
//Request xóa cuộc khảo sát
export const deleteQuestion = createAsyncThunk(
  "survey/deleteQuestion",
  async (data) => {
    try {
      const res = await instance.delete(
        `/survey/deleteQuestions?idSurvey=${data.idSurvey}&idQuestion=${data.idQuestion}`
      );
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);

//Request lấy dữ liệu cuộc khảo sát theo id

export const getDetailSurvey = createAsyncThunk(
  "store/getDetailSurvey",
  async (id) => {
    try {
      const res = await instance.get(`/survey/detailSurvey/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);

// request lấy dữ liệu thống kê các cuộc khảo sát
export const getDataStatisticsSurvey = createAsyncThunk(
  "survey/getDataStatisticsSurvey",
  async (config) => {
    try {
      const res = await instance.post("/reportSurvey/getReport", config);
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// lấy thông tin dữ liệu thống kê tổng quát
export const getReportSurveyOverView = createAsyncThunk(
  "survey/getReportSurveyOverView",
  async (body) => {
    try {
      const res = await instance.post(
        "/reportSurvey/getReportSurveyOverView",
        body
      );
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// lấy câu hỏi theo id
export const getListQuestionById = createAsyncThunk(
  "survey/getListQuestionById",
  async (id) => {
    try {
      const res = await instance.get(
        `/reportSurvey/getListQuestion?surveyId=${id}`
      );
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// lấy danh sách thông kê theo từng câu hỏi
export const getReportQuestionsSurvey = createAsyncThunk(
  "survey/getReportQuestionsSurvey",
  async (body) => {
    try {
      console.log(body);
      const res = await instance.post(
        `/reportSurvey/getReportQuestionsSurvey`,
        body
      );
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// lấy danh sách thông kê theo từng câu hỏi
export const getReportSurveyByCard = createAsyncThunk(
  "survey/getReportSurveyByCard",
  async (body) => {
    try {
      console.log(body);
      const res = await instance.post(
        `/reportSurvey/getReportSurveyByCard`,
        body
      );
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// lấy dự liệu chi tiết theo thẻ khách hàng
export const getDetailReportSurveyByCard = createAsyncThunk(
  "survey/getDetailReportSurveyByCard",
  async (body) => {
    try {
      const res = await instance.get(
        `/reportSurvey/getDetailReportSurveyByCard?id=${body.id}&card=${body.card}&time=${body.time}`
      );
      return { data: res.data.data, status: res.data.status };
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// lấy log khảo sát
export const getLogSurvey = createAsyncThunk(
  "survey/getLogSurvey",

  async (id) => {
    try {
      const res = await instance.get(`/surveyLog/getLog/${id}
      `);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
